import { render, staticRenderFns } from "./hushi.vue?vue&type=template&id=1035a956&scoped=true"
import script from "./hushi.vue?vue&type=script&lang=js"
export * from "./hushi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1035a956",
  null
  
)

export default component.exports